import React, { Children, useMemo } from "react";
import Select, { components } from "react-select";
import Iconify from "../../../layouts/components/iconify/iconify";

const FilterControl = ({ children, icon, label, ...props }) => {
  const childArray = Children.toArray(children);
  const valueContainer = childArray[0];
  const indicators = childArray.slice(1);

  return (
    <components.Control {...props} className="overview-filter-control">
      <span className="overview-filter-icon" aria-hidden="true">
        <Iconify icon={icon} />
      </span>
      <div className="overview-filter-meta">
        <span className="overview-filter-label">{label}</span>
        <div className="overview-filter-value-slot">{valueContainer}</div>
      </div>
      {indicators}
    </components.Control>
  );
};

const FilterDropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <Iconify icon="mdi:chevron-down" />
  </components.DropdownIndicator>
);

/**
 * Labeled filter dropdown matching the Team Overview filter mockup.
 * Shows icon + caption + selected value with a chevron.
 */
const OverviewFilterField = ({
  label,
  icon,
  value,
  options,
  onChange,
  placeholder = "All",
  isSearchable = true,
  isClearable = true,
}) => {
  const selectComponents = useMemo(
    () => ({
      Control: (props) => <FilterControl {...props} icon={icon} label={label} />,
      DropdownIndicator: FilterDropdownIndicator,
      IndicatorSeparator: () => null,
    }),
    [icon, label]
  );

  return (
    <div className="overview-filter-field">
      <Select
        className="overview-filter-select"
        classNamePrefix="overview-filter"
        value={value}
        options={options}
        onChange={onChange}
        placeholder={placeholder}
        isSearchable={isSearchable}
        isClearable={isClearable}
        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
        menuPosition="fixed"
        menuPlacement="auto"
        components={selectComponents}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          control: (base, state) => ({
            ...base,
            minHeight: 54,
            borderRadius: 8,
            borderColor: state.isFocused ? "var(--themeColor, #3b82f6)" : "#e5e7eb",
            boxShadow: "none",
            backgroundColor: "#fff",
            cursor: "pointer",
            paddingLeft: 8,
            paddingRight: 4,
            gap: 10,
            "&:hover": {
              borderColor: "var(--themeColor, #3b82f6)",
            },
          }),
          valueContainer: (base) => ({
            ...base,
            padding: 0,
            margin: 0,
          }),
          singleValue: (base) => ({
            ...base,
            margin: 0,
            maxWidth: "100%",
            fontSize: 13,
            fontWeight: 600,
            color: "var(--textColor, #0f172a)",
            lineHeight: 1.2,
          }),
          placeholder: (base) => ({
            ...base,
            margin: 0,
            fontSize: 13,
            fontWeight: 600,
            color: "var(--textColor, #0f172a)",
            lineHeight: 1.2,
          }),
          input: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
            fontSize: 13,
            fontWeight: 600,
          }),
          indicatorsContainer: (base) => ({
            ...base,
            alignSelf: "center",
          }),
          dropdownIndicator: (base) => ({
            ...base,
            padding: "0 8px",
            color: "#94a3b8",
          }),
          clearIndicator: (base) => ({
            ...base,
            padding: "0 2px",
            color: "#94a3b8",
          }),
          menu: (base) => ({
            ...base,
            borderRadius: 8,
            overflow: "hidden",
            zIndex: 20,
          }),
        }}
      />
    </div>
  );
};

export default OverviewFilterField;
